const React = require("react");

function LightningBoltIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13 10V3L4 14h7v7l9-11h-7z"
  }));
}

module.exports = LightningBoltIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/LightningBoltIcon.js
 ** module id = 551
 ** module chunks = 0
 **/